import React from "react";
import { Row, Col, Card } from "antd";
import "./AboutContact.css";

const AboutUs = () => {
  return (
    <div className="page-container">
      <Row justify="center" className="section-margin-bottom">
        <Col xs={24} md={16} lg={12} className="centered-text">
          <h1 className="about-heading">About SpoFlex</h1>
          <p className="about-description">
            SPOFLEX (PRIVATE) LTD - Innovating the Future of Sports and Esports Community
          </p>
        </Col>
      </Row>

      <Row gutter={[40, 40]} className="section-margin-bottom">
        <Col xs={24} md={12}>
          <h2 className="subheading">Our Story</h2>
          <p className="story-text">
            SpoFlex is a groundbreaking platform built to unify the entire sports and esports
            community under one digital roof. From passionate players and grassroots organizers to
            global sponsors and professional recruiters, SpoFlex provides smart, seamless tools to
            connect, compete, and grow. Whether it&apos;s discovering tournaments, showcasing your
            performance, managing events, or endorsing talent, SpoFlex makes it effortless. We
            believe every athlete deserves visibility, every event deserves reach, and every sponsor
            deserves real value. At SpoFlex, we don&apos;t just support sports, we power the
            ecosystem behind it.
          </p>
        </Col>
        <Col xs={24} md={12}>
          <img className="homeimage" alt="img" width="95%" src="/images/homesports.png" />
        </Col>
      </Row>

      <Row justify="center" style={{ marginBottom: "40px" }}>
        <Col span={24} className="centered-text">
          <h2 className="team-heading">Meet Our Team</h2>
          <p className="team-subheading">The passionate minds driving innovation at Spoflex</p>
        </Col>
      </Row>

      <Row gutter={[30, 30]} justify="center" style={{ marginBottom: "50px" }}>
        {[
          {
            initials: "NK",
            name: "Nouman Khalid",
            role: "Chief Executive Officer",
            desc: "Visionary leader driving innovation in sports technology"
          },
          {
            initials: "MA",
            name: "Muhammad Ahsan",
            role: "Head of Product",
            desc: "Product strategist focused on user-centric solutions"
          },
          {
            initials: "MI",
            name: "Muhammad Idrees",
            role: "Software Engineer",
            desc: "Expert in software development and system architecture"
          }
        ].map((member) => (
          <Col xs={24} sm={12} md={8} lg={6} key={member.initials}>
            <Card
              className="member-card"
              cover={
                <div className="member-avatar-wrapper">
                  <div className="member-avatar">{member.initials}</div>
                </div>
              }>
              <h4 className="card-title">{member.name}</h4>
              <p className="card-subtitle">{member.role}</p>
              <p className="card-description">{member.desc}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AboutUs;
